import { render, staticRenderFns } from "./CarriersChart.vue?vue&type=template&id=cb8960b2&scoped=true"
import script from "./CarriersChart.vue?vue&type=script&lang=js"
export * from "./CarriersChart.vue?vue&type=script&lang=js"
import style0 from "./CarriersChart.vue?vue&type=style&index=0&id=cb8960b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8960b2",
  null
  
)

export default component.exports